// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nHp1","top":"styles_top__2qEdU"};